import { render } from "./PermReviewModal.vue?vue&type=template&id=074b845a&scoped=true"
import script from "./PermReviewModal.vue?vue&type=script&lang=js"
export * from "./PermReviewModal.vue?vue&type=script&lang=js"

import "./PermReviewModal.vue?vue&type=style&index=0&id=074b845a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074b845a"]])

export default __exports__